import { Action } from 'redux-actions';
import { PapiDeviation, PapiModuleAdoptables } from '@wix/da-papi-types';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { Gruser } from '@wix/da-gruser-shared/pkg/types/papi';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { updateModule } from '@wix/da-gruser-shared/pkg/redux/actions/modules';
import { withOffset } from '@wix/da-shared-react/pkg/Stream';
import { SHOP_ITEMS_STREAM_GROUP_ID, getShopItemsStreamId } from '../../../../../../streams/shop';
import { ShopItemType } from '../../../../../../../types/shop';
import { SLIDER_ITEMS_PER_FETCH } from '../../constants';

// Using PapiModuleAdoptables as a template since originals follow similar structure
// TODO: Update to proper PapiModuleOriginals type when available in papi-types
export default (
  gruser: Gruser,
  moduleId: number,
  moduleData: PapiModuleAdoptables
): Action<any>[] => {
  const { results } = moduleData;
  const deviations: PapiDeviation[] = results ?? [];
  const normalized = normalize(deviations, [deviationSchema]);

  return [
    withOffset.actions.initialize({
      streamId: getShopItemsStreamId(ShopItemType.ORIGINALS),
      groupId: SHOP_ITEMS_STREAM_GROUP_ID,
      streamParams: {
        moduleId,
        shopItemType: ShopItemType.ORIGINALS,
      },
      itemsPerFetch: SLIDER_ITEMS_PER_FETCH,
      items: normalized.result,
      entities: normalized.entities,
      hasMore: moduleData.hasMore,
      total: moduleData.total,
    }),
    updateModule(gruser, {
      id: moduleId,
      moduleMeta: {
        isInitialized: true,
      },
    }),
  ] as any;
};
